import { scorePercent } from '../utils/targetScoreIntegrity';
import { getReportClusters } from "../utils/reportClusters";
import { getStudentReportInsights } from "../utils/studentReportInsights";
import React, { useState, useRef, useEffect, useContext } from "react";
import { Box } from "@material-ui/core";
import NavBar from "../components/NavBar";
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";
import { getResponse } from "../utils/getResponse";
import Grid from "@material-ui/core/Grid";
import Progress from "@material-ui/core/LinearProgress";
import { format } from "date-fns";
import ResultFeedback from "../components/resultFeedback.json";
import { Bar, Radar } from "react-chartjs-2";
import Footer from "../components/Footer";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
//import ReactToPrint from "react-to-print";
import { Link, useHistory } from "react-router-dom";
import { isMobile } from "../utils/util";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import AppContext from "../AppContext";
//import StripeModal from '../components/StripeModal';

function Results(props) {
  const [open, setOpen] = useState(false);
  const [benchmarkAvailable, setBenchmarkAvailable] = useState(false);
  const { requestIsProUser } = useContext(AppContext);
  const [loading, setLoading ] = useState(false);
  const history = useHistory();

  // Set constants to change the state of these measures
  //store data of MotivationAtWork
  const [MotivationAtWorkIntrinsic, setMotivationAtWorkIntrinsic] = useState(0);
  const [MotivationAtWorkIdentified, setMotivationAtWorkIdentified] =
    useState(0);
  const [MotivationAtWorkIntrojected, setMotivationAtWorkIntrojected] =
    useState(0);
  const [
    MotivationAtWorkExternalMotivation,
    setMotivationAtWorkExternalMotivation,
  ] = useState(0);
  //store data of EntrepreneurialPassion
  const [EntrepreneurialPassionInventing, setEntrepreneurialPassionInventing] =
    useState(0);
  const [EntrepreneurialPassionFounding, setEntrepreneurialPassionFounding] =
    useState(0);
  const [
    EntrepreneurialPassionDeveloping,
    setEntrepreneurialPassionDeveloping,
  ] = useState(0);
  //store data of IndividualEntrepreneurialOrientation
  const [
    IndividualEntrepreneurialOrientationRiskTaking,
    setIndividualEntrepreneurialOrientationRiskTaking,
  ] = useState(0);
  const [
    IndividualEntrepreneurialOrientationInnovativeness,
    setIndividualEntrepreneurialOrientationInnovativeness,
  ] = useState(0);
  const [
    IndividualEntrepreneurialOrientationProactivity,
    setIndividualEntrepreneurialOrientationProactivity,
  ] = useState(0);
  // //store data of EntrepreneurialSelfEfficacy
  const [
    EntrepreneurialSelfEfficacySearching,
    setEntrepreneurialSelfEfficacySearching,
  ] = useState(0);
  const [
    EntrepreneurialSelfEfficacyPlanning,
    setEntrepreneurialSelfEfficacyPlanning,
  ] = useState(0);
  const [
    EntrepreneurialSelfEfficacyMarshaling,
    setEntrepreneurialSelfEfficacyMarshaling,
  ] = useState(0);
  const [
    EntrepreneurialSelfEfficacyImplementingPeople,
    setEntrepreneurialSelfEfficacyImplementingPeople,
  ] = useState(0);
  const [
    EntrepreneurialSelfEfficacyImplementingFinancial,
    setEntrepreneurialSelfEfficacyImplementingFinancial,
  ] = useState(0);
  // //store data of FearOfFailure
  const [
    FearOfFailureAbilityToFundTheVenture,
    setFearOfFailureAbilityToFundTheVenture,
  ] = useState(0);
  const [FearOfFailurePotentialOfTheIdea, setFearOfFailurePotentialOfTheIdea] =
    useState(0);
  const [
    FearOfFailureThreatToSocialEsteem,
    setFearOfFailureThreatToSocialEsteem,
  ] = useState(0);
  const [FearOfFailureOpportunityCosts, setFearOfFailureOpportunityCosts] =
    useState(0);
  const [FearOfFailurePersonalAbility, setFearOfFailurePersonalAbility] =
    useState(0);
  const [FearOfFailureFinancialSecurity, setFearOfFailureFinancialSecurity] =
    useState(0);
  const [FearOfFailureVenturesCapacity, setFearOfFailureVenturesCapacity] =
    useState(0);
  // //store data of TheBigFive
  const [TheBigFiveExtraversion, setTheBigFiveExtraversion] = useState(0);
  const [TheBigFiveAgreeableness, setTheBigFiveAgreeableness] = useState(0);
  const [TheBigFiveConscientiousness, setTheBigFiveConscientiousness] =
    useState(0);
  const [TheBigFiveNeuroticism, setTheBigFiveNeuroticism] = useState(0);
  const [TheBigFiveOpenness, setTheBigFiveOpenness] = useState(0);
  // Growth Orientation
  const [GrowthOrientationValue, setGrowthOrientationValue] = useState(0);
  // Growth Mindset
  const [GrowthMindsetValue, setGrowthMindsetValue] = useState(0);
  // Cognitive Flexibility
  const [CognitiveFlexibilityValue, setCognitiveFlexibilityValue] = useState(0);
  // Grit
  const [GritValue, setGritValue] = useState(0);
  // Resilience
  const [ResilienceValue, setResilienceValue] = useState(0);
  // store RuleBreaking data
  const [RuleBreakingValue, setRuleBreakingValue] = useState(0);
  // Empathy
  const [EmpathyValue, setEmpathyValue] = useState(0);
  //Need To Achieve
  const [NeedToAchieveValue, setNeedToAchieveValue] = useState(0);
  //Imposter Syndrome
  const [ImposterSyndromeValue, setImposterSyndromeValue] = useState(0);
  // Tolerate Ambiguity
  const [ToleranceForAmbiguityValue, setToleranceForAmbiguityValue] =
    useState(0);
  // store Curiosity data
  const [CuriosityJoyousExploration, setCuriosityJoyousExploration] =
    useState(0);
  const [CuriosityDeprivationSensitivity, setCuriosityDeprivationSensitivity] =
    useState(0);
  const [CuriosityStressTolerance, setCuriosityStressTolerance] = useState(0);
  const [CuriosityThrillSeeking, setCuriosityThrillSeeking] = useState(0);
  const [CuriosityOvertSocial, setCuriosityOvertSocial] = useState(0);
  const [CuriosityCovertSocial, setCuriosityCovertSocial] = useState(0);
  const [HarmoniousPassionValue, setHarmoniousPassionValue] = useState(0);
  const [ObsessivePassionValue, setObsessivePassionValue] = useState(0);

  const [type, setType] = useState({
    name: "",
    path: "PassionScale.HarmoniousPassion",
    res: 0,
  });

  useEffect(() => {
    let cancelled = false;
    fetch('/api/results/benchmarks', { credentials: 'include' })
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        if (cancelled || !data || !(typeof data.resultSet?.MotivationAtWork?.Intrinsic === 'number' && Number.isFinite(data.resultSet.MotivationAtWork.Intrinsic) &&
            typeof data.resultSet?.MotivationAtWork?.Identified === 'number' && Number.isFinite(data.resultSet.MotivationAtWork.Identified) &&
            typeof data.resultSet?.MotivationAtWork?.Introjected === 'number' && Number.isFinite(data.resultSet.MotivationAtWork.Introjected) &&
            typeof data.resultSet?.MotivationAtWork?.ExternalMotivation === 'number' && Number.isFinite(data.resultSet.MotivationAtWork.ExternalMotivation) &&
            typeof data.resultSet?.EntrepreneurialPassion?.Inventing === 'number' && Number.isFinite(data.resultSet.EntrepreneurialPassion.Inventing) &&
            typeof data.resultSet?.EntrepreneurialPassion?.Founding === 'number' && Number.isFinite(data.resultSet.EntrepreneurialPassion.Founding) &&
            typeof data.resultSet?.EntrepreneurialPassion?.Developing === 'number' && Number.isFinite(data.resultSet.EntrepreneurialPassion.Developing) &&
            typeof data.resultSet?.IndividualEntrepreneurialOrientation?.RiskTaking === 'number' && Number.isFinite(data.resultSet.IndividualEntrepreneurialOrientation.RiskTaking) &&
            typeof data.resultSet?.IndividualEntrepreneurialOrientation?.Innovativeness === 'number' && Number.isFinite(data.resultSet.IndividualEntrepreneurialOrientation.Innovativeness) &&
            typeof data.resultSet?.IndividualEntrepreneurialOrientation?.Proactivity === 'number' && Number.isFinite(data.resultSet.IndividualEntrepreneurialOrientation.Proactivity) &&
            typeof data.resultSet?.EntrepreneurialSelfEfficacy?.Searching === 'number' && Number.isFinite(data.resultSet.EntrepreneurialSelfEfficacy.Searching) &&
            typeof data.resultSet?.EntrepreneurialSelfEfficacy?.Planning === 'number' && Number.isFinite(data.resultSet.EntrepreneurialSelfEfficacy.Planning) &&
            typeof data.resultSet?.EntrepreneurialSelfEfficacy?.Marshaling === 'number' && Number.isFinite(data.resultSet.EntrepreneurialSelfEfficacy.Marshaling) &&
            typeof data.resultSet?.EntrepreneurialSelfEfficacy?.ImplementingPeople === 'number' && Number.isFinite(data.resultSet.EntrepreneurialSelfEfficacy.ImplementingPeople) &&
            typeof data.resultSet?.EntrepreneurialSelfEfficacy?.ImplementingFinancial === 'number' && Number.isFinite(data.resultSet.EntrepreneurialSelfEfficacy.ImplementingFinancial) &&
            typeof data.resultSet?.FearOfFailure?.AbilityToFundTheVenture === 'number' && Number.isFinite(data.resultSet.FearOfFailure.AbilityToFundTheVenture) &&
            typeof data.resultSet?.FearOfFailure?.PotentialOfTheIdea === 'number' && Number.isFinite(data.resultSet.FearOfFailure.PotentialOfTheIdea) &&
            typeof data.resultSet?.FearOfFailure?.ThreatToSocialEsteem === 'number' && Number.isFinite(data.resultSet.FearOfFailure.ThreatToSocialEsteem) &&
            typeof data.resultSet?.FearOfFailure?.OpportunityCosts === 'number' && Number.isFinite(data.resultSet.FearOfFailure.OpportunityCosts) &&
            typeof data.resultSet?.FearOfFailure?.PersonalAbility === 'number' && Number.isFinite(data.resultSet.FearOfFailure.PersonalAbility) &&
            typeof data.resultSet?.FearOfFailure?.FinancialSecurity === 'number' && Number.isFinite(data.resultSet.FearOfFailure.FinancialSecurity) &&
            typeof data.resultSet?.FearOfFailure?.VenturesCapacity === 'number' && Number.isFinite(data.resultSet.FearOfFailure.VenturesCapacity) &&
            typeof data.resultSet?.TheBigFive?.Extraversion === 'number' && Number.isFinite(data.resultSet.TheBigFive.Extraversion) &&
            typeof data.resultSet?.TheBigFive?.Agreeableness === 'number' && Number.isFinite(data.resultSet.TheBigFive.Agreeableness) &&
            typeof data.resultSet?.TheBigFive?.Conscientiousness === 'number' && Number.isFinite(data.resultSet.TheBigFive.Conscientiousness) &&
            typeof data.resultSet?.TheBigFive?.Neuroticism === 'number' && Number.isFinite(data.resultSet.TheBigFive.Neuroticism) &&
            typeof data.resultSet?.TheBigFive?.Openness === 'number' && Number.isFinite(data.resultSet.TheBigFive.Openness) &&
            typeof data.resultSet?.Curiosity?.JoyousExploration === 'number' && Number.isFinite(data.resultSet.Curiosity.JoyousExploration) &&
            typeof data.resultSet?.Curiosity?.DeprivationSensitivity === 'number' && Number.isFinite(data.resultSet.Curiosity.DeprivationSensitivity) &&
            typeof data.resultSet?.Curiosity?.StressTolerance === 'number' && Number.isFinite(data.resultSet.Curiosity.StressTolerance) &&
            typeof data.resultSet?.Curiosity?.ThrillSeeking === 'number' && Number.isFinite(data.resultSet.Curiosity.ThrillSeeking) &&
            typeof data.resultSet?.Curiosity?.OvertSocial === 'number' && Number.isFinite(data.resultSet.Curiosity.OvertSocial) &&
            typeof data.resultSet?.Curiosity?.CovertSocial === 'number' && Number.isFinite(data.resultSet.Curiosity.CovertSocial) &&
            typeof data.resultSet?.GrowthOrientation?.Total === 'number' && Number.isFinite(data.resultSet.GrowthOrientation.Total) &&
            typeof data.resultSet?.GrowthMindset?.Total === 'number' && Number.isFinite(data.resultSet.GrowthMindset.Total) &&
            typeof data.resultSet?.CognitiveFlexibility?.Total === 'number' && Number.isFinite(data.resultSet.CognitiveFlexibility.Total) &&
            typeof data.resultSet?.Grit?.Total === 'number' && Number.isFinite(data.resultSet.Grit.Total) &&
            typeof data.resultSet?.Resilience?.Total === 'number' && Number.isFinite(data.resultSet.Resilience.Total) &&
            typeof data.resultSet?.RuleBreaking?.Total === 'number' && Number.isFinite(data.resultSet.RuleBreaking.Total) &&
            typeof data.resultSet?.Empathy?.Total === 'number' && Number.isFinite(data.resultSet.Empathy.Total) &&
            typeof data.resultSet?.NeedToAchieve?.Total === 'number' && Number.isFinite(data.resultSet.NeedToAchieve.Total) &&
            typeof data.resultSet?.ImposterSyndrome?.Total === 'number' && Number.isFinite(data.resultSet.ImposterSyndrome.Total) &&
            typeof data.resultSet?.ToleranceForAmbiguity?.Total === 'number' && Number.isFinite(data.resultSet.ToleranceForAmbiguity.Total))) return;
        setMotivationAtWorkIntrinsic(data.resultSet.MotivationAtWork.Intrinsic);
        setMotivationAtWorkIdentified(data.resultSet.MotivationAtWork.Identified);
        setMotivationAtWorkIntrojected(data.resultSet.MotivationAtWork.Introjected);
        setMotivationAtWorkExternalMotivation(data.resultSet.MotivationAtWork.ExternalMotivation);
        setEntrepreneurialPassionInventing(data.resultSet.EntrepreneurialPassion.Inventing);
        setEntrepreneurialPassionFounding(data.resultSet.EntrepreneurialPassion.Founding);
        setEntrepreneurialPassionDeveloping(data.resultSet.EntrepreneurialPassion.Developing);
        setIndividualEntrepreneurialOrientationRiskTaking(data.resultSet.IndividualEntrepreneurialOrientation.RiskTaking);
        setIndividualEntrepreneurialOrientationInnovativeness(data.resultSet.IndividualEntrepreneurialOrientation.Innovativeness);
        setIndividualEntrepreneurialOrientationProactivity(data.resultSet.IndividualEntrepreneurialOrientation.Proactivity);
        setEntrepreneurialSelfEfficacySearching(data.resultSet.EntrepreneurialSelfEfficacy.Searching);
        setEntrepreneurialSelfEfficacyPlanning(data.resultSet.EntrepreneurialSelfEfficacy.Planning);
        setEntrepreneurialSelfEfficacyMarshaling(data.resultSet.EntrepreneurialSelfEfficacy.Marshaling);
        setEntrepreneurialSelfEfficacyImplementingPeople(data.resultSet.EntrepreneurialSelfEfficacy.ImplementingPeople);
        setEntrepreneurialSelfEfficacyImplementingFinancial(data.resultSet.EntrepreneurialSelfEfficacy.ImplementingFinancial);
        setFearOfFailureAbilityToFundTheVenture(data.resultSet.FearOfFailure.AbilityToFundTheVenture);
        setFearOfFailurePotentialOfTheIdea(data.resultSet.FearOfFailure.PotentialOfTheIdea);
        setFearOfFailureThreatToSocialEsteem(data.resultSet.FearOfFailure.ThreatToSocialEsteem);
        setFearOfFailureOpportunityCosts(data.resultSet.FearOfFailure.OpportunityCosts);
        setFearOfFailurePersonalAbility(data.resultSet.FearOfFailure.PersonalAbility);
        setFearOfFailureFinancialSecurity(data.resultSet.FearOfFailure.FinancialSecurity);
        setFearOfFailureVenturesCapacity(data.resultSet.FearOfFailure.VenturesCapacity);
        setTheBigFiveExtraversion(data.resultSet.TheBigFive.Extraversion);
        setTheBigFiveAgreeableness(data.resultSet.TheBigFive.Agreeableness);
        setTheBigFiveConscientiousness(data.resultSet.TheBigFive.Conscientiousness);
        setTheBigFiveNeuroticism(data.resultSet.TheBigFive.Neuroticism);
        setTheBigFiveOpenness(data.resultSet.TheBigFive.Openness);
        setCuriosityJoyousExploration(data.resultSet.Curiosity.JoyousExploration);
        setCuriosityDeprivationSensitivity(data.resultSet.Curiosity.DeprivationSensitivity);
        setCuriosityStressTolerance(data.resultSet.Curiosity.StressTolerance);
        setCuriosityThrillSeeking(data.resultSet.Curiosity.ThrillSeeking);
        setCuriosityOvertSocial(data.resultSet.Curiosity.OvertSocial);
        setCuriosityCovertSocial(data.resultSet.Curiosity.CovertSocial);
        setGrowthOrientationValue(data.resultSet.GrowthOrientation.Total);
        setGrowthMindsetValue(data.resultSet.GrowthMindset.Total);
        setCognitiveFlexibilityValue(data.resultSet.CognitiveFlexibility.Total);
        setGritValue(data.resultSet.Grit.Total);
        setResilienceValue(data.resultSet.Resilience.Total);
        setRuleBreakingValue(data.resultSet.RuleBreaking.Total);
        setEmpathyValue(data.resultSet.Empathy.Total);
        setNeedToAchieveValue(data.resultSet.NeedToAchieve.Total);
        setImposterSyndromeValue(data.resultSet.ImposterSyndrome.Total);
        setToleranceForAmbiguityValue(data.resultSet.ToleranceForAmbiguity.Total);
        setBenchmarkAvailable(true);
      })
      .catch(() => { /* Personal results remain available without benchmarks. */ });
    return () => { cancelled = true; };
  }, []);

  const withAvailableBenchmark = data => ({
    ...data,
    datasets: data.datasets.filter(dataset =>
      benchmarkAvailable || dataset.label !== 'Average Entremap User'
    ),
  });

  const handleClickOpen = (type) => {
    setType(type);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const componentRef = useRef();

  let resultSet = props.location.state.resultSet;

  function SectionProgress(props) {
    return (
      <div>
        <Typography
          variant="body2"
          style={{
            paddingTop: "5px",
            paddingBottom: "5px",
            textAlign: "center",
          }}
        >
          {props.name}
        </Typography>
        <Progress
          variant="determinate"
          value={props.value}
          style={{ height: "10px", maxWidth: "100px", margin: "auto" }}
        />
      </div>
    );
  }

//NOTE: ERROR OCCUR BELOW when trying to load form question page

  // Chart.js data and options for measures below
  // See chart.js API for more modifications
  let MaWdata = {
    labels: ["Intrinsic", "Identified", "Introjected", "External Motivation"],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.MotivationAtWork.Intrinsic, ResultFeedback.MotivationAtWork.Intrinsic.scale.max),
          scorePercent(resultSet.MotivationAtWork.Identified, ResultFeedback.MotivationAtWork.Identified.scale.max),
          scorePercent(resultSet.MotivationAtWork.Introjected, ResultFeedback.MotivationAtWork.Introjected.scale.max),
          scorePercent(resultSet.MotivationAtWork.ExternalMotivation, ResultFeedback.MotivationAtWork.ExternalMotivation.scale.max),
        ],
        backgroundColor: [
          "rgb(220,146,57)",
          "rgb(220,140,42)",
          "rgb(220,132,36)",
          "rgb(219,125,21)",
        ],
        borderColor: [isMobile ? "#fff" :"rgb(217, 98, 48)"],
        borderWidth: 1,
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(MotivationAtWorkIntrinsic, ResultFeedback.MotivationAtWork.Intrinsic.scale.max),
          scorePercent(MotivationAtWorkIdentified, ResultFeedback.MotivationAtWork.Identified.scale.max),
          scorePercent(MotivationAtWorkIntrojected, ResultFeedback.MotivationAtWork.Introjected.scale.max),
          scorePercent(MotivationAtWorkExternalMotivation, ResultFeedback.MotivationAtWork.ExternalMotivation.scale.max),
        ],
        backgroundColor: ["rgba(74, 73, 72, 0.7)"],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
      },
    ],
  };

  let MaWoptions = {
    scales: {
      xAxes: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: isMobile
          ? {
              font: {
                size: 9,
              },
              color: "#ffffff",
            }
          : {
              font: {
                size: 9,
              },
            },
      },
      yAxes: {
        beginAtZero: true,
        max: 100,
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: isMobile
          ? {
              color: "#ffffff",
            }
          : {},
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 7, color: "#fff" } : { padding: 7 },
      },
    },
  };

  let EPdata = {
    labels: ["Inventing", "Founding", "Developing"],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.EntrepreneurialPassion.Inventing, ResultFeedback.EntrepreneurialPassion.Inventing.scale.max),
          scorePercent(resultSet.EntrepreneurialPassion.Founding, ResultFeedback.EntrepreneurialPassion.Founding.scale.max),
          scorePercent(resultSet.EntrepreneurialPassion.Developing, ResultFeedback.EntrepreneurialPassion.Developing.scale.max),
        ],
        fill: true,
        backgroundColor: [
          isMobile ? "rgba(255, 71, 26, 0.3)" : "rgba(217, 98, 48, 0.2)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
        pointBackgroundColor: ["rgba(217, 98, 48,0.5)"],
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(EntrepreneurialPassionInventing, ResultFeedback.EntrepreneurialPassion.Inventing.scale.max),
          scorePercent(EntrepreneurialPassionFounding, ResultFeedback.EntrepreneurialPassion.Founding.scale.max),
          scorePercent(EntrepreneurialPassionDeveloping, ResultFeedback.EntrepreneurialPassion.Developing.scale.max),
        ],
        backgroundColor: "rgba(74, 73, 72, 0.2)",
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72,0.5)"],
      },
    ],
  };

  let EPOptions = {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 30,
      },
    },
    scale: {
      max: 100,
      min: 0,
    },

    elements: {
      line: {
        tension: 0.3,
      },
    },
    scales: {
      r: {
        pointLabels: isMobile ? { color: "#fff" } : {},
        ticks: {
          backdropColor: isMobile ? "#39AC7E" : "white",

          color: isMobile? "white" : "black"
        },
        grid: {
          circular: true,
          color: isMobile ? "#D3D3D3" : [
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(219,125,21,0.7)",
          ],
        },
      },
    },
    plugins: {
      legend: {
        labels: isMobile
          ? { padding: 0, color: "#fff", font: { size: 10 }, boxWidth: 20 }
          : { padding: 4, boxWidth: 30 },
      },
    },
  };

  let IEOData = {
    labels: ["Risk Taking", "Innovativeness", "Proactivity"],
    datasets: [
      {
        label: "My Data",
        data: [
          (resultSet.IndividualEntrepreneurialOrientation.RiskTaking /
            ResultFeedback.IndividualEntrepreneurialOrientation.RiskTaking.scale
              .max) *
            100,
          (resultSet.IndividualEntrepreneurialOrientation.Innovativeness /
            ResultFeedback.IndividualEntrepreneurialOrientation.Innovativeness
              .scale.max) *
            100,
          (resultSet.IndividualEntrepreneurialOrientation.Proactivity /
            ResultFeedback.IndividualEntrepreneurialOrientation.Proactivity
              .scale.max) *
            100,
        ],
        backgroundColor: [
          isMobile ? "rgba(255, 71, 26, 0.3)" : "rgba(217, 98, 48, 0.2)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
        pointBackgroundColor: ["rgb(217, 98, 48,0.5)"],
      },
      {
        label: "Average Entremap User",
        data: [
          (IndividualEntrepreneurialOrientationRiskTaking /
            ResultFeedback.IndividualEntrepreneurialOrientation.RiskTaking.scale
              .max) *
            100,
          (IndividualEntrepreneurialOrientationInnovativeness /
            ResultFeedback.IndividualEntrepreneurialOrientation.Innovativeness
              .scale.max) *
            100,
          (IndividualEntrepreneurialOrientationProactivity /
            ResultFeedback.IndividualEntrepreneurialOrientation.Proactivity
              .scale.max) *
            100,
        ],
        backgroundColor: [
          isMobile ? "rgba(240,196,172, 0.4)" : "rgba(74, 73, 72, 0.2)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72,0.5)"],
      },
    ],
  };

  let IEOOptions = {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 30,
      },
    },
    scale: {
      max: 100,
      min: 0,
    },

    elements: {
      line: {
        tension: 0.3,
      },
    },
    scales: {
      r: {
        pointLabels: isMobile ? { color: "#fff" } : {},
        ticks: {
          backdropColor: isMobile ? "#39AC7E" : "white",

          color: isMobile? "white" : "black"
        },
        grid: {
          circular: true,
          color: isMobile ? "#D3D3D3" : [
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(219,125,21,0.7)",
          ],
        },
      },
    },
    plugins: {
      legend: {
        labels: isMobile
          ? { padding: 0, color: "#fff", font: { size: 10 }, boxWidth: 20 }
          : { padding: 4, boxWidth: 30 },
      },
    },
  };

  let ESEData = {
    labels: [
      "Searching",
      "Planning",
      "Marshaling",
      ["Implementing", "(People)"],
      ["Implementing", "(Financial)"],
    ],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.EntrepreneurialSelfEfficacy.Searching, ResultFeedback.EntrepreneurialSelfEfficacy.Searching.scale.max),
          scorePercent(resultSet.EntrepreneurialSelfEfficacy.Planning, ResultFeedback.EntrepreneurialSelfEfficacy.Planning.scale.max),
          scorePercent(resultSet.EntrepreneurialSelfEfficacy.Marshaling, ResultFeedback.EntrepreneurialSelfEfficacy.Marshaling.scale.max),
          (resultSet.EntrepreneurialSelfEfficacy.ImplementingPeople /
            ResultFeedback.EntrepreneurialSelfEfficacy.ImplementingPeople.scale
              .max) *
            100,
          (resultSet.EntrepreneurialSelfEfficacy.ImplementingFinancial /
            ResultFeedback.EntrepreneurialSelfEfficacy.ImplementingFinancial
              .scale.max) *
            100,
        ],
        backgroundColor: [
          "rgb(227,156,68)",
          "rgb(220,146,57)",
          "rgb(220,140,42)",
          "rgb(220,132,36)",
          "rgb(219,125,21)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(EntrepreneurialSelfEfficacySearching, ResultFeedback.EntrepreneurialSelfEfficacy.Searching.scale.max),
          scorePercent(EntrepreneurialSelfEfficacyPlanning, ResultFeedback.EntrepreneurialSelfEfficacy.Planning.scale.max),
          scorePercent(EntrepreneurialSelfEfficacyMarshaling, ResultFeedback.EntrepreneurialSelfEfficacy.Marshaling.scale.max),
          (EntrepreneurialSelfEfficacyImplementingPeople /
            ResultFeedback.EntrepreneurialSelfEfficacy.ImplementingPeople.scale
              .max) *
            100,
          (EntrepreneurialSelfEfficacyImplementingFinancial /
            ResultFeedback.EntrepreneurialSelfEfficacy.ImplementingFinancial
              .scale.max) *
            100,
        ],
        backgroundColor: ["rgba(74, 73, 72, 0.7)"],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
      },
    ],
  };

  let ESEOptions = {
    scales: {
      yAxes: {
        beginAtZero: true,
        max: 100,
        ticks: isMobile
          ? {
              color: "#ffffff",
            }
          : {},
          grid: {
            color: isMobile ? "#D3D3D3" : "black"
          },
      },
      xAxes: {
        display: true,
        ticks: isMobile
          ? {
              color: "#ffffff",
              font: {
                size: 9,
              },
            }
          : {
              font: {
                size: 9,
              },
            },
            grid: {
              color: isMobile ? "#D3D3D3" : "black"
            },
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 7, color: "#fff" } : { padding: 7 },
      },
    },
  };

  let FOFData = {
    labels: [
      ["Ability", "to Fund", "the Venture"],
      ["Potential", "of the", "Idea"],
      ["Threat to", "Social", "Esteem"],
      ["Opportunity", "Costs"],
      ["Personal", "Ability"],
      ["Financial", "Security"],
      ["Venture's", "Capacity"],
    ],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.FearOfFailure.AbilityToFundTheVenture, ResultFeedback.FearOfFailure.AbilityToFundTheVenture.scale.max),
          scorePercent(resultSet.FearOfFailure.PotentialOfTheIdea, ResultFeedback.FearOfFailure.PotentialOfTheIdea.scale.max),
          scorePercent(resultSet.FearOfFailure.ThreatToSocialEsteem, ResultFeedback.FearOfFailure.ThreatToSocialEsteem.scale.max),
          scorePercent(resultSet.FearOfFailure.OpportunityCosts, ResultFeedback.FearOfFailure.OpportunityCosts.scale.max),

          scorePercent(resultSet.FearOfFailure.PersonalAbility, ResultFeedback.FearOfFailure.PersonalAbility.scale.max),
          scorePercent(resultSet.FearOfFailure.FinancialSecurity, ResultFeedback.FearOfFailure.FinancialSecurity.scale.max),
          scorePercent(resultSet.FearOfFailure.VenturesCapacity, ResultFeedback.FearOfFailure.VenturesCapacity.scale.max),
        ],
        backgroundColor: [
          "rgb(228,166,91)",
          "rgb(227,156,77)",
          "rgb(227,156,68)",
          "rgb(220,146,57)",
          "rgb(220,140,42)",
          "rgb(220,132,36)",
          "rgb(219,125,21)",
        ],
        borderColor: isMobile ? "#fff" : ["rgb(217, 98, 48)"],
        borderWidth: 1,
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(FearOfFailureAbilityToFundTheVenture, ResultFeedback.FearOfFailure.AbilityToFundTheVenture.scale.max),
          scorePercent(FearOfFailurePotentialOfTheIdea, ResultFeedback.FearOfFailure.PotentialOfTheIdea.scale.max),
          scorePercent(FearOfFailureThreatToSocialEsteem, ResultFeedback.FearOfFailure.ThreatToSocialEsteem.scale.max),
          scorePercent(FearOfFailureOpportunityCosts, ResultFeedback.FearOfFailure.OpportunityCosts.scale.max),

          scorePercent(FearOfFailurePersonalAbility, ResultFeedback.FearOfFailure.PersonalAbility.scale.max),
          scorePercent(FearOfFailureFinancialSecurity, ResultFeedback.FearOfFailure.FinancialSecurity.scale.max),
          scorePercent(FearOfFailureVenturesCapacity, ResultFeedback.FearOfFailure.VenturesCapacity.scale.max),
        ],
        backgroundColor: ["rgba(74, 73, 72, 0.7)"],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
      },
    ],
  };

  let FOFOptions = {
    scales: {
      yAxes: {
        beginAtZero: true,
        max: 100,
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: isMobile
          ? {
              color: "#ffffff",
            }
          : {},
      },
      xAxes: {
        display: true,
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: isMobile
          ? {
              color: "#ffffff",
              font: {
                size: 8,
              },
            }
          : {
              font: {
                size: 8,
              },
            },
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 7, color: "#fff" } : { padding: 7 },
      },
    },
  };

  let TBFdata = {
    labels: [
      "Extraversion",
      "Agreeableness",
      "Conscientiousness",
      "Neuroticism",
      "Openness",
    ],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.TheBigFive.Extraversion, ResultFeedback.TheBigFive.Extraversion.scale.max),
          scorePercent(resultSet.TheBigFive.Agreeableness, ResultFeedback.TheBigFive.Agreeableness.scale.max),
          scorePercent(resultSet.TheBigFive.Conscientiousness, ResultFeedback.TheBigFive.Conscientiousness.scale.max),
          scorePercent(resultSet.TheBigFive.Neuroticism, ResultFeedback.TheBigFive.Neuroticism.scale.max),
          scorePercent(resultSet.TheBigFive.Openness, ResultFeedback.TheBigFive.Openness.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(255, 71, 26, 0.3)" : "rgb(217, 98, 48 ,0.2)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
        pointBackgroundColor: ["rgb(217, 98, 48,0.5)"],
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(TheBigFiveExtraversion, ResultFeedback.TheBigFive.Extraversion.scale.max),
          scorePercent(TheBigFiveAgreeableness, ResultFeedback.TheBigFive.Agreeableness.scale.max),
          scorePercent(TheBigFiveConscientiousness, ResultFeedback.TheBigFive.Conscientiousness.scale.max),
          scorePercent(TheBigFiveNeuroticism, ResultFeedback.TheBigFive.Neuroticism.scale.max),
          scorePercent(TheBigFiveOpenness, ResultFeedback.TheBigFive.Openness.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(240,196,172, 0.4)" : "rgba(74, 73, 72, 0.2)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72,0.5)"],
      },
    ],
  };

  let TBFOptions = {
    scale: {
      max: 100,
      min: 0,
    },
    elements: {
      line: {
        tension: 0.2,
      },
    },
    scales: {
      r: {
        pointLabels: isMobile ? { color: "#fff" } : {},
        ticks: {
          backdropColor: isMobile ? "#39AC7E" : "white",

          color: isMobile ? "white" : "black",
        },
        grid: {
          circular: true,
          color: isMobile ? "#D3D3D3" : [
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(219,125,21,0.7)",
          ],
        },
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 7, color: "#fff" } : { padding: 7 },
      },
    },
  };

  let CUdata = {
    labels: [
      "Joyous Exploration",
      "Deprivation Sensitivity",
      "Stress Tolerance",
      "Thrill Seeking",
      "Overt Social",
      "Covert Social",
    ],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.Curiosity.JoyousExploration, ResultFeedback.Curiosity.JoyousExploration.scale.max),
          scorePercent(resultSet.Curiosity.DeprivationSensitivity, ResultFeedback.Curiosity.DeprivationSensitivity.scale.max),
          scorePercent(resultSet.Curiosity.StressTolerance, ResultFeedback.Curiosity.StressTolerance.scale.max),
          scorePercent(resultSet.Curiosity.ThrillSeeking, ResultFeedback.Curiosity.ThrillSeeking.scale.max),
          scorePercent(resultSet.Curiosity.OvertSocial, ResultFeedback.Curiosity.OvertSocial.scale.max),
          scorePercent(resultSet.Curiosity.CovertSocial, ResultFeedback.Curiosity.CovertSocial.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(255, 71, 26, 0.3)" : "rgb(217, 98, 48 ,0.2)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
        pointBackgroundColor: ["rgb(217, 98, 48,0.5)"],
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(CuriosityJoyousExploration, ResultFeedback.Curiosity.JoyousExploration.scale.max),
          scorePercent(CuriosityDeprivationSensitivity, ResultFeedback.Curiosity.DeprivationSensitivity.scale.max),
          scorePercent(CuriosityStressTolerance, ResultFeedback.Curiosity.StressTolerance.scale.max),
          scorePercent(CuriosityThrillSeeking, ResultFeedback.Curiosity.ThrillSeeking.scale.max),
          scorePercent(CuriosityOvertSocial, ResultFeedback.Curiosity.OvertSocial.scale.max),
          scorePercent(CuriosityCovertSocial, ResultFeedback.Curiosity.CovertSocial.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(240,196,172, 0.4)" : "rgba(74, 73, 72, 0.2)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72,0.5)"],
      },
    ],
  };

  let CUOptions = {
    scale: {
      max: 100,
      min: 0,
    },
    elements: {
      line: {
        tension: 0.2,
      },
    },
    scales: {
      r: {
        pointLabels: isMobile ? { color: "#fff" } : {},
        ticks: {
          backdropColor: isMobile ? "#39AC7E" : "white",

          color: isMobile ? "white" : "black",
        },
        grid: {
          circular: true,
          color: isMobile ? "#D3D3D3" :
            ["rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(219,125,21,0.7)"
          ],
        },
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 3, color: "#fff" } : { padding: 3},
      },
    },
  };

  let growthData = {
    labels: [
      "Growth Orientation",
      "Growth Mindset",
      "Cognitive Flexibility",
      "Grit",
      "Resilience",
    ],

    datasets: [
      {
        label: "My Data",

        data: [
          scorePercent(resultSet.GrowthOrientation.Total, ResultFeedback.GrowthOrientation.Total.scale.max),

          scorePercent(resultSet.GrowthMindset.Total, ResultFeedback.GrowthMindset.Total.scale.max),

          scorePercent(resultSet.CognitiveFlexibility.Total, ResultFeedback.CognitiveFlexibility.Total.scale.max),

          scorePercent(resultSet.Grit.Total, ResultFeedback.Grit.Total.scale.max),

          scorePercent(resultSet.Resilience.Total, ResultFeedback.Resilience.Total.scale.max),
        ],

        backgroundColor: [isMobile ? "rgb(220,132,36)" : "rgb(220,132,36)"],

        borderColor: [isMobile ? "#fff" :"rgb(217, 98, 48)"],

        borderWidth: 1,

      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(GrowthOrientationValue, ResultFeedback.GrowthOrientation.Total.scale.max),
          scorePercent(GrowthMindsetValue, ResultFeedback.GrowthMindset.Total.scale.max),
          scorePercent(CognitiveFlexibilityValue, ResultFeedback.CognitiveFlexibility.Total.scale.max),
          scorePercent(GritValue, ResultFeedback.Grit.Total.scale.max),
          scorePercent(ResilienceValue, ResultFeedback.Resilience.Total.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(74, 73, 72, 0.7)" : "rgba(74, 73, 72, 0.7)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
      },
    ],
  };

  let growthOptions = {
    indexAxis: "y",
    plugins: {
      legend: {
        labels: isMobile
          ? { padding: 3, color: "#fff"}
          : { padding: 4},
      },
    },
    scales: {
      x: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: {
          color: isMobile ? "white" : "black"
        }
      },
      y: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        
        },
        ticks: {
          color: isMobile ? "white" : "black"
        }
      }
    },
    scale: {
      max: 100,

      min: 0,
      

      elements: {
        bar: {
          borderWidth: 2,
        },
      },
    },
    
      responsive: true,
    
  };

  let growth2Data = {
    labels: [
      "Rule-Breaking",
      "Empathy",
      "Need to Achieve",
      "Imposter Syndrome",
      "Tolerance for Ambiguity",
    ],

    datasets: [
      {
        label: "My Data",

        data: [
          (resultSet.RuleBreaking.Total / // change to rulebreaking.Total
            ResultFeedback.RuleBreaking.Total.scale.max) *
            100,

          scorePercent(resultSet.Empathy.Total, ResultFeedback.Empathy.Total.scale.max),

          scorePercent(resultSet.NeedToAchieve.Total, ResultFeedback.NeedToAchieve.Total.scale.max),

          scorePercent(resultSet.ImposterSyndrome.Total, ResultFeedback.ImposterSyndrome.Total.scale.max),

          scorePercent(resultSet.ToleranceForAmbiguity.Total, ResultFeedback.ToleranceForAmbiguity.Total.scale.max),
        ],

        backgroundColor: [isMobile ? "rgb(220,132,36)" : "rgb(220,132,36)"],

        borderColor: ["rgb(217, 98, 48)"],

        borderWidth: 1,

      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(RuleBreakingValue, ResultFeedback.RuleBreaking.Total.scale.max),
          scorePercent(EmpathyValue, ResultFeedback.Empathy.Total.scale.max),
          scorePercent(NeedToAchieveValue, ResultFeedback.NeedToAchieve.Total.scale.max),
          scorePercent(ImposterSyndromeValue, ResultFeedback.ImposterSyndrome.Total.scale.max),
          scorePercent(ToleranceForAmbiguityValue, ResultFeedback.ToleranceForAmbiguity.Total.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(74, 73, 72, 0.7)" : "rgba(74, 73, 72, 0.7)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        //pointBackgroundColor: [isMobile ? '#fff' : 'rgb(74, 73, 72,0.5)'],
      },
    ],
  };

  let growth2Options = {
    indexAxis: "y",
    plugins: {
      legend: {
        labels: isMobile
          ? { padding: 3, color: "#fff"}
          : { padding: 4},
      },
    },
    scales: {
      x: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: {
          color: isMobile ? "white" : "black"
        }
      },
      y: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        
        },
        ticks: {
          color: isMobile ? "white" : "black"
        }
      }
    },

    scale: {
      max: 100,

      min: 0,
      

      elements: {
        bar: {
          borderWidth: 2,
        },
      },
    },
    
      responsive: true,
    
  };

  // Create and Export PDF Document
  const getDocument = () => {
    // TARGETS SECTION WITH REF as ID in return code
    const input = document.getElementById("REF");
    html2canvas(input, {
      logging: true,
      letterRendering: 1,
      useCORS: true,
    }).then((canvas) => {
      const imgWidth = 180;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const imgData = canvas.toDataURL("img/png");
      const document = new jsPDF("p", "mm", "a4");
      // Background Setup
      document.setFillColor("#39AC7E");
      document.rect(0, 0, 230, 297, "F");
      document.setFillColor("white");
      document.roundedRect(5, 5, 200, 280, 5, 5, "F");
      // Document Footer
      document.setFillColor("#d96230");
      document.rect(0, 282, 230, 15, "F");
      document.setTextColor("white");
      document.setFontSize(11);
      document.text(
        "© Copyright 2023 - Entremap - All rights reserved.",
        5,
        291
      );
      document.text("Contact: entremapco@gmail.com", 147, 291);
// PDF content area
const contentTop = 15;
const contentBottom = 277;
const contentHeight = contentBottom - contentTop;

// Calculate how much content fits on one PDF page
const sliceHeightPx = Math.floor(
  (contentHeight / imgHeight) * canvas.height
);

let sourceY = 0;
let pageIndex = 0;

while (sourceY < canvas.height) {
  const currentSliceHeight = Math.min(
    sliceHeightPx,
    canvas.height - sourceY
  );

  // Create a canvas for this page only
  const pageCanvas = window.document.createElement("canvas");
  pageCanvas.width = canvas.width;
  pageCanvas.height = currentSliceHeight;

  const pageContext = pageCanvas.getContext("2d");

  pageContext.drawImage(
    canvas,
    0,
    sourceY,
    canvas.width,
    currentSliceHeight,
    0,
    0,
    canvas.width,
    currentSliceHeight
  );

  const pageImgData = pageCanvas.toDataURL("image/png");
  const sliceHeightMm =
    (currentSliceHeight * imgWidth) / canvas.width;

  // Create additional pages after page 1
  if (pageIndex > 0) {
    document.addPage();

    document.setFillColor("#39AC7E");
    document.rect(0, 0, 230, 297, "F");

    document.setFillColor("white");
    document.roundedRect(5, 5, 200, 280, 5, 5, "F");
  }

  // Add this section of the report
  document.addImage(
    pageImgData,
    "PNG",
    15,
    contentTop,
    imgWidth,
    sliceHeightMm
  );

  // Footer
  document.setFillColor("#d96230");
  document.rect(0, 282, 230, 15, "F");
  document.setTextColor("white");
  document.setFontSize(11);

  document.text(
    "© Copyright 2023 - Entremap - All rights reserved.",
    5,
    291
  );

  document.text(
    "Contact: entremapco@gmail.com",
    147,
    291
  );

  sourceY += currentSliceHeight;
  pageIndex += 1;
}
      // Process Document
      document.save("YourMindsetReport.PDF");
    });
  };


  const getFullReport = () => {
    if(loading) return;
    setLoading(true);
    requestIsProUser().then(isProUser => {
      history.push({
        pathname: isProUser ? '/resultExtended' : '/stripe',
        state: isProUser ? { resultSet } : {},
      });
    }).then(() => {
      setLoading(false);
    });
  }

  // D-19: Build the seven meaning-based report clusters.
  const reportClusters = getReportClusters(resultSet);

  const studentReportInsights = getStudentReportInsights(reportClusters);

  return (
    <div className="emap-report-page"
      style={{
        backgroundColor: '#f5f8f5',
      }}
    >
      <NavBar isLoggedIn={true} />
      <div
        style={{
          margin: "auto",
          width: "100%",
          paddingTop: "30px",
          paddingBottom: "50px",
        }}
      >
       <Box
  boxShadow={1}
  color="text.primary"
  id={"Result"}
  style={{
    margin: "auto",
    width: isMobile ? "100vw" : "794px",
    backgroundColor: isMobile ? "transparent" : "white",
    padding: isMobile ? "0 12px" : "2vw",
    marginBottom: "10px",
    boxSizing: isMobile ? "border-box" : "unset",
    boxShadow: isMobile ? "none" : undefined,
    display: 'flex',
    justifyContent: 'center', // Center the buttons
    gap: isMobile ? '8px' : '20px' // Evenly space the buttons
  }}
>
  <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
    <Button
      variant="contained"
      size={isMobile ? "small" : "large"}
      color="primary"
      style={{ flex: 1, margin: '0 10px' }}
    >
      Print
    </Button>
    <Button
      variant="contained"
      size={isMobile ? "small" : "large"}
      color="primary"
      style={{ flex: 1, margin: '0 10px' }}
      component={Link}
      to={{ pathname: "/resultdetails", state: props.location.state }}
    >
      Details
    </Button>
    <Button
      variant="contained"
      size={isMobile ? "small" : "large"}
      color="primary"
      style={{ flex: 1, margin: '0 10px' }}
      onClick={() => getDocument()}
    >
      Export PDF
    </Button>
    <Button
      variant="contained"
      size={isMobile ? "small" : "large"}
      color="primary"
      style={{ flex: 1, margin: '0 10px' }}
      onClick={() => getFullReport()}
    >
      Full Report
    </Button>
  </div>
</Box>
<Box
  boxShadow={1}
  color="text.primary"
  id={"Result"}
  style={{
    margin: "auto",
    width: isMobile ? "100vw" : "794px",
    minHeight: "1123px",
    backgroundColor: isMobile ? "transparent" : "white",
    padding: isMobile ? "0 12px" : "2vw",
    boxSizing: isMobile ? "border-box" : "unset",
    color: "#122c33",
  }}
>
  <div
    id="REF"
    ref={componentRef}
    style={{
      width: isMobile ? "100%" : "790px",
      minHeight: "1120px",
    }}
  >


            <Typography variant="h5" align="center">
              Entremap Mindset Report
            </Typography>
            <Typography variant="body2">{resultSet.name}</Typography>
            <Grid container spacing={1}>
              <Grid variant="body2" item xs="6">
                {format(new Date(resultSet.date), "dd/MM/yyyy")}
              </Grid>
              <Grid item xs="6" align="right"></Grid>
            </Grid>
            <div style={{ height: 12, width: "100%" }} />
            <Divider></Divider>
            <div style={{ height: 12, width: "100%" }} />
            <Typography variant="body2"> {resultSet.summary || "Summary not available."}</Typography>

            {/* D-19: Meaning-based report cluster summary */}
            <div style={{ marginTop: "24px", marginBottom: "24px" }}>
              {reportClusters.some(cluster => cluster.measures.some(measure => measure.score === null)) && <div role="status" style={{ border: "1px solid #dba68e", background: "#fff6ef", color: "#71371f", padding: "16px", borderRadius: 10, marginBottom: 20 }}><strong>Some scores are unavailable.</strong> Missing or invalid answers are shown as Not available and excluded from cluster averages. This does not indicate a zero score. Contact EntreMap before repeating the assessment.</div>}
              <Typography variant="h6" align="center" style={{ marginBottom: "6px", fontWeight: 600 }}>
                Your EntreMap Profile
              </Typography>
              <Typography variant="body2" align="center" style={{ marginBottom: "20px", opacity: 0.8 }}>
                Your results are grouped into seven areas to help you understand how different measures contribute to your entrepreneurial profile.
              </Typography>
              <Grid container spacing={2}>
                {reportClusters.map((cluster) => (
                  <Grid item xs={12} sm={6} key={cluster.id}>
                    <Box boxShadow={1} style={{ padding: "16px", height: "100%", boxSizing: "border-box", borderRadius: "6px", backgroundColor: isMobile ? "rgba(255,255,255,0.08)" : "#fafafa" }}>
                      <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: "4px" }}>
                        {cluster.name}
                      </Typography>
                      <Typography variant="body2" style={{ marginBottom: "12px", opacity: 0.8 }}>
                        {cluster.meaning}
                      </Typography>
                      <Typography variant="h5" style={{ fontWeight: 600, marginBottom: "12px" }}>
                        {cluster.clusterScore !== null ? `${cluster.clusterScore.toFixed(0)}%` : "Not available"}
                      </Typography>
                      {cluster.measures.length > 0 ? (
                        cluster.measures.map((measure) => (
                          <div key={measure.path} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px", gap: "12px" }}>
                            <Typography variant="body2">{measure.name}</Typography>
                            <Typography variant="body2" style={{ fontWeight: 600, whiteSpace: "nowrap" }}>
                              {Number.isFinite(measure.score) ? `${measure.score.toFixed(0)}%` : "Not available"}
                            </Typography>
                          </div>
                        ))
                      ) : (
                        <Typography variant="body2" style={{ opacity: 0.7 }}>
                          No mapped measures are currently available for this cluster.
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                ))}
              </Grid>
              <Typography variant="caption" display="block" style={{ marginTop: "14px", opacity: 0.75, textAlign: "center" }}>
                Cluster scores summarise the available measures shown within each area. They are descriptive report scores rather than population norms.
              </Typography>
            </div>
            <Divider />
            <div style={{ height: 20, width: "100%" }} />

            {/* D-08: Student-facing report interpretation */}
            <div style={{ marginBottom: "28px" }}>
              <Typography
                variant="h6"
                align="center"
                style={{ marginBottom: "16px", fontWeight: 600 }}
              >
                Understanding Your Results
              </Typography>

              <Box
                boxShadow={1}
                style={{
                  padding: "16px",
                  marginBottom: "18px",
                  borderRadius: "6px",
                  backgroundColor: isMobile
                    ? "rgba(255,255,255,0.08)"
                    : "#fafafa",
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: 600, marginBottom: "8px" }}
                >
                  Profile Summary
                </Typography>
                <Typography variant="body2">
                  {studentReportInsights.profileSummary}
                </Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box
                    boxShadow={1}
                    style={{
                      padding: "16px",
                      height: "100%",
                      boxSizing: "border-box",
                      borderRadius: "6px",
                      backgroundColor: isMobile
                        ? "rgba(255,255,255,0.08)"
                        : "#fafafa",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      style={{ fontWeight: 600, marginBottom: "10px" }}
                    >
                      Key Strengths
                    </Typography>

                    {studentReportInsights.strengths.length > 0 ? (
                      studentReportInsights.strengths.map((strength) => (
                        <div
                          key={`strength-${strength.path}`}
                          style={{ marginBottom: "12px" }}
                        >
                          <Typography
                            variant="body2"
                            style={{ fontWeight: 600 }}
                          >
                            {strength.name} – {strength.score.toFixed(0)}%
                          </Typography>
                          <Typography
                            variant="caption"
                            display="block"
                            style={{ opacity: 0.75 }}
                          >
                            {strength.clusterName}
                          </Typography>
                        </div>
                      ))
                    ) : (
                      <Typography variant="body2">
                        Strength insights are not currently available.
                      </Typography>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box
                    boxShadow={1}
                    style={{
                      padding: "16px",
                      height: "100%",
                      boxSizing: "border-box",
                      borderRadius: "6px",
                      backgroundColor: isMobile
                        ? "rgba(255,255,255,0.08)"
                        : "#fafafa",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      style={{ fontWeight: 600, marginBottom: "10px" }}
                    >
                      Development Opportunities
                    </Typography>

                    {studentReportInsights.developmentAreas.length > 0 ? (
                      studentReportInsights.developmentAreas.map((area) => (
                        <div
                          key={`development-${area.path}`}
                          style={{ marginBottom: "12px" }}
                        >
                          <Typography
                            variant="body2"
                            style={{ fontWeight: 600 }}
                          >
                            {area.name} – {area.score.toFixed(0)}%
                          </Typography>
                          <Typography
                            variant="caption"
                            display="block"
                            style={{ opacity: 0.75 }}
                          >
                            {area.clusterName}
                          </Typography>
                        </div>
                      ))
                    ) : (
                      <Typography variant="body2">
                        Development insights are not currently available.
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>

              <div style={{ height: 20, width: "100%" }} />

              <Typography
                variant="subtitle1"
                style={{ fontWeight: 600, marginBottom: "10px" }}
              >
                Practical Next Steps
              </Typography>

              {studentReportInsights.actions.length > 0 ? (
                studentReportInsights.actions.map((action) => (
                  <Box
                    key={`action-${action.measure}`}
                    boxShadow={1}
                    style={{
                      padding: "16px",
                      marginBottom: "12px",
                      borderRadius: "6px",
                      backgroundColor: isMobile
                        ? "rgba(255,255,255,0.08)"
                        : "#fafafa",
                    }}
                  >
                    <Typography
                      variant="body2"
                      style={{ fontWeight: 600, marginBottom: "8px" }}
                    >
                      {action.measure}
                    </Typography>

                    <Typography variant="body2" style={{ marginBottom: "5px" }}>
                      <strong>Study:</strong> {action.study}
                    </Typography>

                    <Typography variant="body2" style={{ marginBottom: "5px" }}>
                      <strong>Career:</strong> {action.career}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Entrepreneurship:</strong>{" "}
                      {action.entrepreneurship}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography variant="body2">
                  Practical actions are not currently available.
                </Typography>
              )}

              <Typography
                variant="caption"
                display="block"
                style={{
                  marginTop: "14px",
                  opacity: 0.75,
                  textAlign: "center",
                }}
              >
                Strengths and development opportunities are relative patterns
                within your current results. They are intended to support
                reflection and are not population rankings or diagnostic
                conclusions.
              </Typography>
            </div>

            <Divider />
            <div style={{ height: 20, width: "100%" }} />

            {/* Existing detailed result charts continue below */}
            <Grid columns="2">
              <Grid container spacing={1}>
                <Grid item xs={isMobile ? "12" : "6"}>
                  <Typography
                    variant="body1"
                    style={{ paddingTop: "60px", paddingBottom: "0px" }}
                    align="center"
                    onClick={() => {
                      handleClickOpen({
                        name: "Well-Rounded Cognitive Function",
                        path: "Curiosity.Total",
                        res: resultSet.Curiosity.Total,
                      });
                    }}
                  >
                    Well-Rounded Cognitive Function
                  </Typography>
                  <Bar data={withAvailableBenchmark(growthData)} options={growthOptions}></Bar>
                </Grid>
                <Grid
                  item
                  xs={isMobile ? "12" : "6"}
                  style={{ maxHeight: "250px" }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      paddingTop: "5px",
                      paddingBottom: "0px",
                      marginBottom: 12,
                    }}
                    align="center"
                    onClick={() => {
                      handleClickOpen({
                        name: "Entrepreneurial Passion",
                        path: "EntrepreneurialPassion.Total",
                        res: resultSet.EntrepreneurialPassion.Total,
                      });
                    }}
                  >
                    Entrepreneurial Passion
                  </Typography>
                  <Radar
                    data={withAvailableBenchmark(EPdata)}
                    options={EPOptions}
                    style={{ margin: "auto", height: "65%" }}
                  ></Radar>
                </Grid>
              </Grid>
            </Grid>
            <div style={{ height: 12, width: "100%" }} />
            <Grid columns="2">
              <Grid container spacing={3}>
                <Grid item xs={isMobile ? "12" : "6"}>
                  <Typography
                    variant="body1"
                    style={{ paddingTop: "60px", paddingBottom: "0px" }}
                    align="center"
                    onClick={() => {
                      handleClickOpen({
                        name: "Adaptive Success",
                        path: "Curiosity.Total",
                        res: resultSet.Curiosity.Total,
                      });
                    }}
                  >
                    Adaptive Success
                  </Typography>
                  <Bar data={withAvailableBenchmark(growth2Data)} options={growth2Options}></Bar>
                </Grid>

                <Grid item xs= {isMobile ? "12" : "6"}>
                  <Typography
                    variant="body1"
                    style={{ paddingTop: "27px", paddingBottom: "0px" }}
                    align="center"
                    onClick={() => {
                      handleClickOpen({
                        name: "Individual Entrepreneurial Orientation",
                        path: "IndividualEntrepreneurialOrientation.RiskTaking",
                        res: resultSet.IndividualEntrepreneurialOrientation
                          .RiskTaking,
                      });
                    }}
                  >
                    Individual Entrepreneurial Orientation
                  </Typography>
                  <div style={{ maxHeight: "250px" }}>
                    <Radar
                      data={withAvailableBenchmark(IEOData)}
                      options={IEOOptions}
                      style={{ margin: "auto" }}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid columns="2">
              <Grid container spacing={1}>
                <Grid item xs={isMobile ? "12" : "6"}>
                  <Typography
                    variant="body1"
                    style={{
                      paddingTop: "0px",
                      paddingBottom: "0px",
                    }}
                    align="center"
                    onClick={() => {
                      handleClickOpen({
                        name: "Entrepreneurial Self Efficacy",
                        path: "EntrepreneurialSelfEfficacy.Total",
                        res: resultSet.EntrepreneurialSelfEfficacy.Total,
                      });
                    }}
                  >
                    Entrepreneurial Self Efficacy
                  </Typography>
                  <Bar options={ESEOptions} data={withAvailableBenchmark(ESEData)} />
                </Grid>

                <Grid item xs={isMobile ? "12" : "6"}>
                  <Typography
                    variant="body1"
                    style={{
                      paddingTop: "0px",
                      paddingBottom: "0px",
                      paddingLeft: "0px",
                    }}
                    align="center"
                    onClick={() => {
                      handleClickOpen({
                        name: "Curiosity",
                        path: "Curiosity.Total",
                        res: resultSet.Curiosity.Total,
                      });
                    }}
                  >
                    Curiosity
                  </Typography>
                  <Radar data={withAvailableBenchmark(CUdata)} options={CUOptions}>style={{ margin: "auto" }}</Radar>
                </Grid>
              </Grid>
            </Grid>
            <Grid columns="2">
              <Grid container spacing={1}>
                <Grid item xs= {isMobile ? "12" : "6"}>
                  <Typography
                    variant="body1"
                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    align="center"
                    onClick={() => {
                      handleClickOpen({
                        name: "Motivation at Work",
                        path: "MotivationAtWork.Total",
                        res: resultSet.MotivationAtWork.Total,
                      });
                    }}
                  >
                    Motivation at Work
                  </Typography>
                  <Bar options={MaWoptions} data={withAvailableBenchmark(MaWdata)} />
                  <Typography
  variant="caption"
  display="block"
  align="center"
  style={{ paddingTop: "10px", opacity: 0.8 }}
>
  {benchmarkAvailable
    ? 'Benchmark averages are calculated from completed survey responses currently available in the system.'
    : 'Benchmark comparison is currently unavailable. Your personal results are shown.'}
</Typography>
                </Grid>
                <Grid item xs={isMobile ? "12" : "5"}>
                  <Typography
                    variant="body1"
                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    align="center"
                    onClick={() => {
                      handleClickOpen({
                        name: "The Big Five",
                        path: "TheBigFive.Total",
                        res: resultSet.TheBigFive.Total,
                      });
                    }}
                  >
                    The Big Five
                  </Typography>
                  <Radar data={withAvailableBenchmark(TBFdata)} options={TBFOptions}>style={{ margin: "auto" }}</Radar>
                </Grid>
              </Grid>
            </Grid>
            <Grid columns="2">
              <Grid container spacing={1}>
              <Grid item xs={isMobile ? '12' : '6'}>
                <Typography
                  variant="body1"
                  style={{ paddingTop: '30px', paddingBottom: '0px', paddingLeft: '10px' }}
                  align="center"
                  onClick={() => {
                    handleClickOpen({
                      name: 'Fear of Failure',
                      path: 'FearOfFailure.Total',
                      res: resultSet.FearOfFailure.Total,
                    });
                  }}
                >
                  Fear of Failure
                </Typography>
                <Bar options={FOFOptions} data={withAvailableBenchmark(FOFData)} />
              </Grid>
                </Grid>
              </Grid>
          </div>
        </Box>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{type.name}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {getResponse(`${type.path}`, type.res)}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" variant="contained">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Footer />
    </div>
  );
}

export default Results;


